
import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: "Cos'è esattamente il Brand Capital e perché dovrebbe interessarmi?",
    answer: "Il Brand Capital è il valore economico del tuo brand, misurato e certificato secondo standard internazionali. Non è solo un numero: è la trasformazione dei tuoi investimenti in marketing da costo a patrimonio aziendale. Significa che ogni euro speso per costruire il tuo brand diventa un attivo che aumenta il valore della tua azienda, migliora il bilancio e ti apre nuove opportunità di crescita."
  },
  {
    question: "La mia azienda è piccola, ha senso valorizzare il brand?",
    answer: "Assolutamente sì. Anzi, per le PMI è ancora più strategico. Un brand valorizzato ti permette di competere con aziende più grandi, di ottenere condizioni migliori dalle banche, di attrarre partner e investitori. Non serve essere una multinazionale: serve avere un brand riconoscibile e una strategia chiara. Noi lavoriamo proprio con PMI che vogliono fare il salto di qualità."
  },
  {
    question: "Quanto costa valorizzare il brand?",
    answer: "Dipende dalle dimensioni della tua azienda e dagli obiettivi. Ma la domanda giusta è: quanto ti costa NON valorizzarlo? Ogni anno spendi in marketing senza capitalizzare nulla. Con la valorizzazione, quegli stessi investimenti diventano patrimonio. Offriamo una pre-analisi gratuita per capire insieme il potenziale del tuo brand e darti un'idea chiara dei costi e dei benefici."
  },
  {
    question: "Quanto tempo ci vuole per completare la valorizzazione?",
    answer: "Il processo completo richiede mediamente 60-90 giorni, dalla raccolta dati alla certificazione finale. Ma i benefici iniziano subito: già dalla pre-analisi avrai una visione chiara del valore del tuo brand e potrai iniziare a pianificare le strategie di crescita. Non è un processo burocratico: è un percorso strategico che ti accompagniamo passo dopo passo."
  },
  {
    question: "Cosa succede dopo la valorizzazione? Devo fare qualcosa?",
    answer: "Dopo la certificazione, il valore del brand entra nel tuo bilancio come attivo immateriale. Da quel momento puoi usarlo per migliorare i rapporti con le banche, attrarre investitori, strutturare royalty, pianificare operazioni straordinarie. Ti forniamo anche un piano di governance per mantenere e far crescere il valore nel tempo. Non ti lasciamo solo: ti affianchiamo nella fase di utilizzo strategico."
  },
  {
    question: "Il Brand Capital migliora davvero l'accesso al credito?",
    answer: "Sì, in modo concreto. Un brand valorizzato aumenta il patrimonio netto della tua azienda, migliorando tutti gli indici di bilancio che le banche guardano. Inoltre, dimostra che hai un asset strategico che genera valore nel tempo. Molti nostri clienti hanno ottenuto finanziamenti più alti e a condizioni migliori proprio grazie alla valorizzazione del brand."
  },
  {
    question: "Posso valorizzare il brand anche se non ho un bilancio certificato?",
    answer: "Sì, la valorizzazione del brand è possibile anche per aziende in regime semplificato. Quello che conta è avere un brand riconoscibile, una presenza sul mercato e dati misurabili (fatturato, clienti, investimenti marketing). La certificazione segue standard internazionali che si adattano a diverse tipologie di impresa. Nella pre-analisi valutiamo insieme la fattibilità."
  },
  {
    question: "Cosa significa 'royalty sul brand' e come funziona?",
    answer: "È un sistema che ti permette di generare reddito ricorrente dal tuo brand. In pratica, costituisci una holding personale che detiene il marchio e lo concede in licenza alla tua azienda operativa, che paga una royalty periodica. Questo ti permette di ottimizzare la fiscalità, proteggere il brand e creare un flusso di reddito stabile e prevedibile. È una strategia usata dalle grandi aziende, ora accessibile anche alle PMI."
  },
  {
    question: "La valorizzazione del brand è riconosciuta fiscalmente?",
    answer: "Sì, se fatta secondo gli standard internazionali (ISO 10668) e le normative contabili (IAS 38/IFRS). Il valore del brand può essere iscritto a bilancio come attivo immateriale, con tutti i benefici fiscali e patrimoniali che ne derivano. Lavoriamo sempre con commercialisti e revisori per garantire la piena conformità normativa."
  },
  {
    question: "Perché dovrei scegliere voi invece di fare tutto internamente?",
    answer: "La valorizzazione del brand richiede competenze specifiche: analisi finanziaria, marketing strategico, normative internazionali, perizie certificate. Fare tutto internamente significa investire tempo, risorse e rischiare errori costosi. Noi abbiamo un metodo collaudato, certificazioni riconosciute e un team di esperti che ti accompagna in ogni fase. In più, offriamo la pre-analisi gratuita: zero rischi, massima chiarezza."
  },
  {
    question: "Cosa include esattamente la pre-analisi gratuita?",
    answer: "La pre-analisi è un check-up completo del tuo brand. Analizziamo la tua presenza sul mercato, gli investimenti in marketing, il posizionamento competitivo e ti forniamo una stima preliminare del valore del tuo brand. Ricevi un report chiaro con i potenziali benefici economici, i tempi e i passi successivi. È gratuita, senza impegno e ti dà una visione strategica immediata."
  },
  {
    question: "Il valore del brand può diminuire nel tempo?",
    answer: "Come ogni asset, il brand va gestito e protetto. Se smetti di investire, se la qualità cala o se perdi rilevanza sul mercato, il valore può diminuire. Per questo ti forniamo un piano di governance: strategie concrete per mantenere e far crescere il valore nel tempo. Non è un certificato da mettere nel cassetto: è uno strumento vivo che richiede attenzione strategica."
  }
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="space-y-5">
          {faqData.map((faq, index) => (
            <div 
              key={index}
              className="border-2 border-[#0B1F3B]/10 rounded-xl overflow-hidden hover:border-[#E879F9] transition-all hover:shadow-xl"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between bg-white hover:bg-[#E879F9]/5 transition-all cursor-pointer text-left"
              >
                <h3 className="text-xl font-bold text-[#0B1F3B] pr-6">
                  {faq.question}
                </h3>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-3xl text-[#22C55E]`}></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-7 pt-3 bg-[#F8F9FA]">
                  <p className="text-lg text-[#0B1F3B]/80 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
